// extracted by mini-css-extract-plugin
export var blue = "_35-h";
export var brand = "_35-d";
export var darkGrey = "_35-g";
export var disabled = "_35-6";
export var disabledSubtle = "_35-7";
export var error = "_35-8";
export var green = "_35-i";
export var grey = "_35-f";
export var icon = "_35-0";
export var inherit = "_35-c";
export var lightGrey = "_35-e";
export var orange = "_35-k";
export var pink = "_35-m";
export var primary = "_35-1";
export var purple = "_35-n";
export var quaternary = "_35-4";
export var quinary = "_35-5";
export var red = "_35-l";
export var secondary = "_35-2";
export var success = "_35-b";
export var tertiary = "_35-3";
export var warning = "_35-9";
export var warningSecondary = "_35-a";
export var white = "_35-o";
export var yellow = "_35-j";